module.exports = __webpack_public_path__ + "static/forecast/weather/daymodsnow-46d2822ff4014013ff88b2a6a1026615.svg";